import { apiSignin, API_BASE_URL } from "../../../api";
import { loginFail, loginSuccess, setAuthenticatedUser } from "../actions/authActions";
import { put, call } from "redux-saga/effects";
import { updateUser } from "../actions/userActions";
import Swal from 'sweetalert2';
import { push } from "react-router-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export function* loginSaga(action) {
    try {
        console.group('🔵 LOGIN_REQUEST - Détails complets');
        console.log('📊 action.payload:', action.payload);
        console.log('📊 usernameOrEmail:', action.payload.usernameOrEmail);
        console.log('📊 Type usernameOrEmail:', typeof action.payload.usernameOrEmail);
        console.log('📊 password type:', typeof action.payload.password);
        console.groupEnd();

        // ✅ Vérifier que ce sont bien des strings simples
        const usernameOrEmail = String(action.payload.usernameOrEmail);
        const password = String(action.payload.password);

        console.group('🧪 Valeurs nettoyées');
        console.log('usernameOrEmail:', usernameOrEmail);
        console.log('Type:', typeof usernameOrEmail);
        console.groupEnd();

        // 🌐 Appel API avec paramètres séparés
        const response = yield call(
            apiSignin,
            usernameOrEmail,
            password
        );

        const responseData = response.data;

        console.group('✅ LOGIN_SUCCESS');
        console.log('📥 Response:', responseData);
        console.groupEnd();

        // Extraire les données
        const userData = responseData?.user || responseData;
        const token = responseData?.token;

        // Sauvegarder
        if (token) {
            sessionStorage.setItem('token', token);
            sessionStorage.setItem('loggedIn', "true");
        }

        if (userData) {
            sessionStorage.setItem('email', userData.username || userData.email);
            sessionStorage.setItem('uid', String(userData.id));
            localStorage.setItem('user', JSON.stringify(userData));
        }

        // Dispatch
        yield put(loginSuccess(responseData));
        yield put(setAuthenticatedUser(userData));
        yield put(updateUser(userData));

        // Redirection


    } catch (error) {
        console.group('❌ LOGIN_FAIL - Analyse détaillée');
        console.error('Error complet:', error);
        console.error('Response:', error?.response);
        console.error('Response data:', error?.response?.data);
        console.error('Config:', error?.config);
        console.error('Request data:', error?.config?.data);
        console.groupEnd();

        const status = error?.response?.status;
        const errorData = error?.response?.data;

        let errorMessage = 'Une erreur est survenue';
        let errorTitle = 'Erreur de connexion';

        if (status >= 500) {
            errorMessage = errorData?.message || 'Erreur serveur. Réessayez plus tard.';
            errorTitle = 'Erreur serveur';
        } else if (status === 401 || status === 400) {
            errorMessage = errorData?.message || 'Identifiants incorrects';
            errorTitle = 'Identifiants incorrects';
        }

        Swal.fire({
            icon: 'error',
            title: errorTitle,
            text: errorMessage,
            confirmButtonText: 'Réessayer',
            confirmButtonColor: '#d33'
        });

        yield put(loginFail({
            message: errorMessage,
            status: status,
            details: errorData
        }));
    }
}

export function* logoutSaga() {
    try {
        const token = sessionStorage.getItem('token');
        if (token) {
            // Signal au backend pour enregistrer logoutAt
            yield call(fetch, `${API_BASE_URL}/api/auth/logout`, {
                method: 'POST',
                headers: { 
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
        }
    } catch (error) {
        console.error("Erreur lors de la déconnexion backend:", error);
    } finally {
        // Nettoyage local quoi qu'il arrive
        sessionStorage.clear();
        localStorage.removeItem('user');
        window.location.href = '/';
    }
}
